var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeBranch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_9922)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6758 48C37.9306 48 48.6758 37.2548 48.6758 24C48.6758 10.7452 37.9306 0 24.6758 0C11.4209 0 0.675781 10.7452 0.675781 24C0.675781 37.2548 11.4209 48 24.6758 48Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1128_9922)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6758 48C37.9306 48 48.6758 37.2548 48.6758 24C48.6758 10.7452 37.9306 0 24.6758 0C11.4209 0 0.675781 10.7452 0.675781 24C0.675781 37.2548 11.4209 48 24.6758 48Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1128_9922)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1128_9922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 33,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3043 18.614L36.8651 16.9933C37.5016 16.3323 37.5016 15.2635 36.8651 14.6061L34.8304 12.4931C34.1939 11.8356 33.1646 11.8356 32.5315 12.4931L30.9708 14.1139C30.8117 14.2791 30.8117 14.5463 30.9708 14.7115L34.7288 18.614C34.8879 18.7793 35.1452 18.7793 35.3043 18.614ZM20.7396 24.7385L29.6301 15.5061C29.7892 15.3409 30.0465 15.3409 30.209 15.5061L33.967 19.4086C34.1262 19.5738 34.1262 19.841 33.967 20.0063L25.0765 29.2387L20.963 29.9875C20.4078 30.086 19.9237 29.5867 20.0219 29.0101L20.7396 24.7385ZM24.2098 23.2513C24.0236 23.4447 24.0236 23.7541 24.2098 23.9474C24.396 24.1408 24.6939 24.1408 24.8802 23.9474L30.0939 18.5332C30.2801 18.3398 30.2801 18.0304 30.0939 17.837C29.9077 17.6437 29.6098 17.6437 29.4236 17.837L24.2098 23.2513ZM24.6127 26.9042H22.9876V25.2166H21.7587L21.3761 27.4843L22.429 28.5777L24.6127 28.1804V26.9042ZM15.3424 19.0933C15.3424 18.1213 16.1304 17.3333 17.1024 17.3333H26.0091L28.6758 14.6667H17.1024C14.6577 14.6667 12.6758 16.6486 12.6758 19.0933V32.24C12.6758 34.6848 14.6577 36.6667 17.1024 36.6667H30.2491C32.6939 36.6667 34.6758 34.6848 34.6758 32.24V20.6667L32.0091 22.96V32.24C32.0091 33.212 31.2211 34 30.2491 34H17.1024C16.1304 34 15.3424 33.212 15.3424 32.24V19.0933Z",
    fill: "#E87722"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1128_9922)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.67578,
    y: 8,
    width: 32,
    height: 32,
    fill: "#E87722"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_9922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.675781)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1128_9922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.675781)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1128_9922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8.67578 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeBranch);
export default __webpack_public_path__ + "static/media/change-branch.b0589df06d282019a5e1ce03371c2729.svg";
export { ForwardRef as ReactComponent };